export const FALL_RISK_ITAKI = {
    masterTableName: "MC_FALL_RISK_ITAKI",
    tableName: "MC_FALL_RISK_ITAKI_DET",
    columnName: "FRI_ID",
    columnValue: 0,
    title: "fall-risk-itaki.title-two",
    rows: [
        {
            title: "id",
            value: "ID",
        },
        {
            title: "date",
            value: "PROCESS_TIME",
            headerName: "Tarih",
            type: "date",
        },
        {
            title: "createdby",
            value: "CUSER",
        },
        {
            title: "justification_evaluation",
            value: "JUSTIFICATION_EVALUATIO_XNAME",
        },
        {
            title: "age",
            value: "AGE_XNAME",
        },
        {
            title: "consciousness_status",
            value: "STATE_CONSCIOUSNESS_XNAME",
        },
        {
            title: "fall_history",
            value: "FALL_HISTORY_XVALUE",
            type: "Checkbox"
        },
        {
            title: "diseases",
            value: "DISEASES_XNAME",
        },
        {
            title: "mobility",
            value: "WALKER_SUPPORT_XNAME",
        },
        {
            title: "incontinence",
            value: "EXCRETION",
        },
        {
            title: "vision_status",
            value: "SIGHT_CONDITION_XNAME",
        },
        {
            title: "fall-risk-itaki.has-polypharmacy",
            value: "MEDICINE_4DRUGUSES_XVALUE",
        },
        {
            title: "fall-risk-itaki.has-used-max-two-high-risk-medications-in-last-week",
            value: "MEDICINE_2RISKYDRUGS_XVALUE",
            type: "checkbox"
        },
        {
            title: "fall-risk-itaki.has-used-three-or-more-high-risk-medications-in-last-week",
            value: "MEDICINE_3OR1WEEKRISKY_XVALUE",
            type: "checkbox",
        },
        {
            title: "equipment-usage",
            value: "EQUIPMENT_XNAME",
        },
        {
            title: "note",
            value: "NURSE_NOTE",
        },
        {
            title: "total_score",
            value: "CALC_VALUE",
        },
    ],
    fields: [
        { field: "date", headerName: "datetime", flex: 1 },
        { field: "createdby", headerName: "createdby", flex: 1 },
        { field: "justification_evaluation", headerName: "fall-risk-itaki.justification-evaluation", flex: 1 },
        { field: "age", headerName: "fall-risk-itaki.age", flex: 1 },
        { field: "consciousness_status", headerName: "fall-risk-itaki.consciousness-status", flex: 1 },
        { field: "fall_history", headerName: "fall-risk-itaki.fall-history-in-last-six-months", flex: 1 },
        { field: "diseases", headerName: "fall-risk-itaki.diseases", flex: 1 },
        { field: "mobility", headerName: "fall-risk-itaki.mobility", flex: 1 },
        { field: "incontinence", headerName: "fall-risk-itaki.has-urinary-or-fecal-incontinence", flex: 1 },
        { field: "vision_status", headerName: "fall-risk-itaki.vision-status", flex: 1 },
        { field: "fall-risk-itaki.has-polypharmacy", headerName: "fall-risk-itaki.has-polypharmacy", flex: 1 },
        { field: "fall-risk-itaki.has-used-max-two-high-risk-medications-in-last-week", headerName: "fall-risk-itaki.has-used-max-two-high-risk-medications-in-last-week", flex: 1 },
        { field: "fall-risk-itaki.has-used-three-or-more-high-risk-medications-in-last-week", headerName: "fall-risk-itaki.has-used-three-or-more-high-risk-medications-in-last-week", flex: 1 },
        { field: "equipment-usage", headerName: "fall-risk-itaki.equipment-usage", flex: 1 },
        {
            field: "calc_value",
            headerName: "score",
            flex: 1,
            computed: true,
            calculate: (row: any) => {
                return Number(row.CALC_VALUE) || 0;
            },
        },
        { field: "note", headerName: "note", flex: 1 },
    ],
    mcpConfig: {
        AGE: { mcpId: 120, field: "AGE", scoreField: "AGE_XVALUE" },
        STATE_CONSCIOUSNESS: { mcpId: 121, field: "STATE_CONSCIOUSNESS", scoreField: "STATE_CONSCIOUSNESS_XVALUE" },
        FALL_HISTORY: { mcpId: 122, field: "FALL_HISTORY", scoreField: "FALL_HISTORY_XVALUE" },
        DISEASES: { mcpId: 123, field: "DISEASES", scoreField: "DISEASES_XVALUE" },
        WALKER_SUPPORT: { mcpId: 124, field: "WALKER_SUPPORT", scoreField: "WALKER_SUPPORT_XVALUE" },
        EXCRETION: { mcpId: 125, field: "EXCRETION", scoreField: "EXCRETION_XVALUE" },
        SIGHT_CONDITION: { mcpId: 126, field: "SIGHT_CONDITION", scoreField: "SIGHT_CONDITION_XVALUE" },
        MEDICINE_4DRUGUSES: { mcpId: 130, field: "MEDICINE_4DRUGUSES", scoreField: "MEDICINE_4DRUGUSES" },
        MEDICINE_2RISKYDRUGS: { mcpId: 131, field: "MEDICINE_2RISKYDRUGS", scoreField: "MEDICINE_2RISKYDRUGS" },
        MEDICINE_3OR1WEEKRISKY: { mcpId: 132, field: "MEDICINE_3OR1WEEKRISKY", scoreField: "MEDICINE_3OR1WEEKRISKY" },
        EQUIPMENT: { mcpId: 128, field: "EQUIPMENT", scoreField: "EQUIPMENT" },
        JUSTIFICATION_EVALUATION: { mcpId: 129, field: "JUSTIFICATION_EVALUATION", scoreField: "JUSTIFICATION_EVALUATION_XVALUE" },
    } as Record<string, { mcpId: number; field: string; scoreField: string }>,
    formData: {
        FRI_ID: "",
        PROCESS_TIME: new Date(),
        NURSE_ID: "",
        CTIME: new Date(),
        CUSER: "",
        JUSTIFICATION_EVALUATION: "",
        AGE: "",
        STATE_CONSCIOUSNESS: "",
        FALL_HISTORY: "0",
        DISEASES: "",
        WALKER_SUPPORT: "",
        EXCRETION: "0",
        SIGHT_CONDITION: "",
        MEDICINE: "",
        MEDICINE_4DRUGUSES: "0",
        MEDICINE_2RISKYDRUGS: "0",
        MEDICINE_3OR1WEEKRISKY: "0",
        EQUIPMENT: "",
        NURSE_NOTE: "",
        GENARAL_NOTE: "",
        CALC_VALUE: 0,
    },
    chartScoreField: "CALC_VALUE",
    chartTimeField: "PROCESS_TIME",
};
